import { BORDER, SPACING } from 'app-v2/design-tokens'
import styled from 'styled-components'
import { colors } from 'shared/assets/styles'
import { ResponsiveContainer, media } from 'app/assets/styles'
import { CaptionText } from 'app/common/typography'
import { Card } from 'app-v2/design-systems'

export const StyledBanner = styled.div`
    background-color: ${colors.bbqBrown};
    height: 224px;
    margin-top: 90px;
`

export const StyledErrorBanner = styled.div`
    background-color: ${colors.bbqBrown};
    height: 60vh;
    margin-top: 90px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: ${SPACING.XXL};
`

export const StyledResponsiveContainer = styled(ResponsiveContainer)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 100%;
`

export const StyledMessageContainer = styled.div`
    background-color: ${colors.veryLightGrey};
    box-sizing: border-box;
    border-radius: ${BORDER.RADIUS.S};
    flex-grow: 2;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 680px;

    margin-top: -30px;

    ${media.xsmall`
           margin-top: -60px;
    `};
`

export const StyledResponsiveContainerMessage = styled(ResponsiveContainer)`
    margin-bottom: 128px;
`

export const StyledConversationDiv = styled.div`
    max-width: 90%;
    width: fit-content;
    box-sizing: border-box;
    padding: ${SPACING.XS} ${SPACING.M};
    background-color: ${props =>
        props.customer ? colors.white : colors.lightGrey};
    border-radius: ${props =>
        props.customer
            ? `${SPACING.M} 0px ${SPACING.M} ${SPACING.M}`
            : `0px ${SPACING.M} ${SPACING.M} ${SPACING.M}`};
    margin-bottom: ${SPACING.S};
    margin: ${props =>
        props.customer ? `0 0 ${SPACING.S} auto` : `auto 0 ${SPACING.S} 0`};
    white-space: pre-line;
`

export const StyledExchangeContainer = styled.div`
    gap: ${SPACING.S};
    overflow-y: scroll;
    padding: ${SPACING.L};
`

export const StyledDivider = styled.div`
    display: flex;
    align-items: center;

    &::before,
    ::after {
        flex: 1;
        content: '';
        padding: ${BORDER.WIDTH.XS};
        background-color: ${colors.lightGrey};
        margin: 17px ${SPACING.S};
    }
`

export const StyledImageContainer = styled.div`
    height: 100%;
    display: none;

    ${media.small`
        display: block;
    `};
`

export const StyledImage = styled.img`
    height: 100%;
`

export const StyledTextContainer = styled.div`
    margin-top: 56px;
`

export const StyledCaptionText = styled(CaptionText)`
    opacity: 0.7;
`

export const StyledLoaderContainer = styled.div`
    background-color: ${colors.white};
    min-height: 100vh;
    display: flex;
    flex-direction: row;
    justify-content: center;
`

export const StyledCard = styled(Card)`
    margin-top: ${SPACING.XXL};
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    gap: ${SPACING.XS};
    align-items: center;
`

export const StyledIconContainer = styled.div`
    width: 24px;
`
